import { DocumentoComercialValidacionDtoProps } from "api/DTOs/DocumentoComercialValidacionDto"

const CircularSignStatus = ({
  numFirmados = 0,
  numFirmas = 1,
}: DocumentoComercialValidacionDtoProps) => {
  const percent = numFirmas > 0 ? (numFirmados / numFirmas) * 100 : 0
  const percentStyle = `!tw-bg-[conic-gradient(#3b82f6_0%_${percent}%,_#e5e7eb_${percent}%_100%)]`
  return (
    <div
      className={`tw-h-10 tw-w-10 tw-border tw-border-neutral-25 tw-rounded-full tw-flex tw-justify-center tw-items-center ${percentStyle}`}
    >
      <div className='tw-w-7 tw-h-7 tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-medium tw-bg-white tw-rounded-full'>
        <span>
          {numFirmados}/{numFirmas}
        </span>
      </div>
    </div>
  )
}

export default CircularSignStatus
